module.exports = __webpack_public_path__ + "static/media/revenue-red.8662490d.svg";